// extracted by mini-css-extract-plugin
export default {"slider":"CustomSlider_slider__teUp+","slick-next":"CustomSlider_slick-next__CFHRN"};